export * from './departments-list.component';



// WEBPACK FOOTER //
// ./src/app/components/departments-list/index.ts